module.exports = __webpack_public_path__ + "static/media/vs-code.30670b25.png";